import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Mutations, Actions } from "@/store/enums/StoreEnums";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/panel",
    component: () => import("@/layouts/main-layout/MainLayout.vue"),
    children: [
      {
        path: "/panel",
        name: "ITT Temsilci Paneli",
        component: () => import("@/views/Dashboard.vue"),
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: "/404",
    name: "404",
    component: () => import("@/views/Error404.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  // reset config to initial state
  store.commit(Mutations.RESET_LAYOUT_CONFIG);
  switch (to.name) {
    case "404" || "500":
      next();
      return;
    case "sign-in":
      if (store.getters.isUserAuthenticated) {
        next({ name: "Panel" });
        return;
      }
      break;
  }
  next();
  // Scroll page to top on every route change
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
});

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default router;
